import { getQueryParams } from '../client/config';

// The class and group every event is sent with. Starts from the portal's query
// string and follows the filters, since the app can restore a different class
// from localStorage.
let classContext = null;

export function getClassContext() {
  if (!classContext) {
    const params = getQueryParams();
    classContext = {
      classId: params.classId || null,
      groupId: params.groupId || null
    };
  }

  return classContext;
}

export function setClassContext({ classId, groupId }) {
  classContext = {
    classId: classId || null,
    groupId: groupId || null
  };
}

export function resetClassContext() {
  classContext = null;
}



// WEBPACK FOOTER //
// ./analytics/tracking/class-context.js